// extracted by mini-css-extract-plugin
export default {"root":"EditInternalEligibilityMatrixDialog_root__uSBH9","form":"EditInternalEligibilityMatrixDialog_form__VTfXJ"};